var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v("\n  欢迎登陆资讯管理中心\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }